module.exports = __webpack_public_path__ + "img/09.e2a9483a.jpg";